<h2 id="ALERT_TITLE" mat-dialog-title [ngSwitch]="modalType">
	<ng-container *ngSwitchCase="'discard'">Discard?</ng-container>
	<ng-container *ngSwitchCase="'delete'">Delete?</ng-container>
	<ng-container *ngSwitchCase="'deleteFutureChanges'">Immediately Delete {{ name }}?</ng-container>
	<ng-container *ngSwitchCase="'logout'">Log out?</ng-container>
	<ng-container *ngSwitchCase="'payroll'">End Payroll?</ng-container>
	<ng-container *ngSwitchCase="'deleteNote'">Delete Note?</ng-container>
	<ng-container *ngSwitchCase="'authError'">You are not authorized</ng-container>
</h2>

<mat-dialog-content>
	<p *ngIf="modalType === 'discard'">Are you sure you want to leave this page? Changes will not be saved.</p>
	<p *ngIf="modalType === 'deleteNote'">Are you sure you want to delete note {{ name }}?</p>
	<p *ngIf="modalType === 'deleteFutureChanges'">Are you sure you want to delete {{ name }}?</p>
	<p *ngIf="modalType === 'logout'">Are you sure you want to log out?</p>
	<p *ngIf="modalType === 'payroll'">Are you sure you want to end payroll for the month?</p>
	<p *ngIf="modalType === 'delete'">
		{{ name }} will be archived as of {{ modifiedDate | date: 'MMMM, y' }}. Continue?
	</p>

</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end end">
	<ng-container *ngIf="modalType === 'authError'; else standard">
		<button id="ALERT_CONTINUE" type="button" color="blue" mat-raised-button (click)="discard()">
			Login
		</button>
	</ng-container>
	<ng-template #standard>
		<button id="ALERT_CANCEL" type="button" color="grey" mat-raised-button (click)="close()">
			Cancel
		</button>

		<button
			*ngIf="modalType === 'payroll'"
			id="ALERT_DOWNLOAD_PREVIEW"
			type="button"
			color="blue"
			mat-raised-button
			(click)="downloadPreview()"
		>
			Preview
		</button>

		<button id="ALERT_CONTINUE" type="button" color="primary" mat-raised-button (click)="discard()">
			Continue
		</button>
	</ng-template>

</mat-dialog-actions>
